import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import { Link, useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      switch (err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
          setError('Invalid email or password.');
          break;
        case 'auth/too-many-requests':
          setError('Too many attempts. Please try again later.');
          break;
        default:
          setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="29" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="66" y="29" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="8" y="48" width="26" height="5" rx="2.5" fill="#2ECC71"/>
            <rect x="66" y="48" width="26" height="5" rx="2.5" fill="#2ECC71"/>
            <rect x="8" y="68" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="66" y="68" width="26" height="4" rx="2" fill="#2ECC71"/>
            <circle cx="50" cy="50" r="17" fill="none" stroke="#ffffff" strokeWidth="3.5"/>
          </svg>
        </div>
        <h1 className="auth-title">Coach Connect</h1>
        <p className="auth-subtitle">Sign in to your coaching portal</p>

        <form onSubmit={handleLogin} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              required
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/forgot-password">Forgot password?</Link>
          <span className="auth-links-divider">&bull;</span>
          <Link to="/signup">Create an account</Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
